import { createFileRoute } from '@tanstack/react-router'

import { TaxFormPage } from '@/features/tax-forms/pages/tax-form'
import Head from '@/lib/navigation/head'

/** Public: a contractor opens this from the payer's email, with no account (guard.ts isPublicPath). */
function TaxFormRoute() {
  const { token } = Route.useParams()
  return (
    <>
      <Head>
        <title>Tax form | Nonresident Tax</title>
      </Head>
      <TaxFormPage token={token} />
    </>
  )
}

export const Route = createFileRoute('/_bare/tax-form/$token')({
  component: TaxFormRoute,
})
